import { useContext, useState } from 'react';
import ActionIcon from './action-icon';
import { Grip } from 'lucide-react';
import SideBarContext from '../../contexts/side-bar-context';
import IconHover from './icon-hover';
import { getCommandKey } from '../../lib/utils';
import SecondaryDropdownContainer from './secondary-dropdown-container';
import AppItem from './app-item';
import PrimarySearch from './primary-search';
import EmptyStateText from './empty-state-text';
import { getCachedBusiness } from '../../lib/utils';

const AppToggle = ({ position }) => {
    const { toggleMyApps, isMyAppsOpen } = useContext(SideBarContext)
    const [searchQuery, setSearchQuery] = useState('');
    const installedPegs =localStorage.getItem(`${getCachedBusiness()}_installed_pegs`)

    

    const pegs = [
        { id: "space", name: 'space', image: 'space' },
        { id: "drive", name: 'drive', icon: 'hard-drive', tag: "Beta" },
        { id: "contacts", name: 'contacts', icon: 'contact' },
        { id: "ironduels", name: 'ironduels', image: 'ironduel' },
    ]

    const filteredPegs = installedPegs 
        ? pegs.filter(peg => peg.id === 'space' || JSON.parse(installedPegs).includes(peg.id))
        : pegs

    const handleSearch = (value) => {
        setSearchQuery(value);
    }

    const searchFilteredPegs = filteredPegs.filter(peg =>
        peg.name.toLowerCase().includes(searchQuery.toLowerCase())
    );

    return (
        <div className='relative'>
            <IconHover position={position || 'right'} onClick={toggleMyApps} content={`${isMyAppsOpen ? 'Close' : 'Open'} App switcher`} command={`${getCommandKey("⌘", "Ctrl")} + ${getCommandKey("⇧", "Shift")} + P`} additionalclasses='!p-[10px] !rounded-[8px]'>
                <ActionIcon color='custom-text-grey-800'>
                    <Grip size={20} />
                </ActionIcon>
            </IconHover>
            <SecondaryDropdownContainer isOpen={isMyAppsOpen} toggleDropdown={toggleMyApps} additionalclasses='!top-[36.58px] !left-[-205px]'>
                <PrimarySearch onSearch={handleSearch} placeholder='Search' onFocus={(e) => e.stopPropagation()} additionalclasses='!w-full' />
                {searchFilteredPegs.length > 0 ? (
                    searchFilteredPegs.map((peg) => (
                        <AppItem key={peg.name} peg={peg.name} image={peg.image} icon={peg.icon} tag={peg.tag}>
                            {peg.name.charAt(0).toUpperCase() + peg.name.slice(1)}
                        </AppItem>
                    ))
                ) : (
                    <div className='flex items-center justify-center h-[50px]'>
                        <EmptyStateText >No pegs found</EmptyStateText>
                    </div>
                )}
                <>
                    <div className='h-[1px] w-full custom-bg-grey-50' />
                    <AppItem peg='accounts' icon='user-round'>
                        Manage Pegs
                    </AppItem>
                </>
            </SecondaryDropdownContainer>
        </div>
    );
};

export default AppToggle;